import { type ComponentPropsWithoutRef, memo } from 'react';

import { Command } from '@air/cmdk';
import { cn } from '@air/utils-tailwind';

export type SearchCommandItemProps = ComponentPropsWithoutRef<typeof Command.Item>;

export const SearchCommandItem = memo(({ className, ...restOfProps }: SearchCommandItemProps) => {
  return (
    <Command.Item
      className={cn(
        'group/command-item flex min-h-10 cursor-pointer items-center gap-3 rounded-12 p-2 text-14 transition-colors',
        'ads:hover:bg-hover-subtle hover:bg-gray-4 ads:aria-selected:bg-hover-subtle aria-selected:bg-gray-4 ads:data-[selected=true]:bg-hover-subtle data-[selected=true]:bg-gray-4',
        className,
      )}
      data-testid="SEARCH_COMMAND_ITEM"
      {...restOfProps}
    />
  );
});

SearchCommandItem.displayName = 'SearchCommandItem';
